import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import regeneratorRuntime from "/home/runner/work/cloud-services/cloud-services/node_modules/.pnpm/next@12.2.5_bw5me6qlxrwkidqrhljke6qy5u/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import "@blackbird/common/augmentations";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import fetch from "isomorphic-unfetch";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContrastLink } from "../link";
export var ComponentStatus;
(function(ComponentStatus) {
    ComponentStatus["OPERATIONAL"] = "operational";
    ComponentStatus["UNDER_MAINTENANCE"] = "under_maintenance";
    ComponentStatus["DEGRADED_PERFORMANCE"] = "degraded_performance";
    ComponentStatus["PARTIAL_OUTAGE"] = "partial_outage";
    ComponentStatus["MAJOR_OUTAGE"] = "major_outage";
})(ComponentStatus || (ComponentStatus = {}));
var useStyles = makeStyles(function(theme) {
    return createStyles({
        statusContainer: {
            display: "inline-flex",
            alignItems: "center"
        },
        statusIndicator: {
            width: "0.75rem",
            height: "0.75rem",
            borderRadius: "50%",
            backgroundColor: "#aaa",
            lineHeight: "1rem",
            marginRight: "5px"
        },
        none: {
            backgroundColor: "#2ecc71"
        },
        operational: {
            backgroundColor: "#2ecc71"
        },
        minor: {
            backgroundColor: "#f1c40f"
        },
        major: {
            backgroundColor: "#e67e22"
        },
        critical: {
            backgroundColor: "#e74c3c"
        },
        maintenance: {
            backgroundColor: "#3498db"
        }
    });
});
var fetchStatus = function(path) {
    return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return fetch(path);
                case 3:
                    response = _ctx.sent;
                    if (response.ok) {
                        _ctx.next = 6;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 6:
                    return _ctx.abrupt("return", response.json());
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
};
var StatusPage = function() {
    var t = useTranslation([
        "shared"
    ]).t;
    var ref = useState(), state = ref[0], setState = ref[1];
    var classes = useStyles({});
    var onFetch = useCallback(function() {
        return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.t0 = setState;
                        _ctx.next = 3;
                        return fetchStatus("https://585cxbjqrwh1.statuspage.io/api/v2/status.json");
                    case 3:
                        _ctx.t1 = _ctx.sent;
                        (0, _ctx.t0)(_ctx.t1);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
    }, []);
    useEffect(function() {
        onFetch();
        var interval = setInterval(onFetch, 5..minutes);
        // Clear timeout if the component is unmounted
        return function() {
            return clearInterval(interval);
        };
    }, []);
    var indicator = classes.none;
    switch(state === null || state === void 0 ? void 0 : state.status.indicator){
        case "operational":
            indicator = classes.operational;
            break;
        case "minor":
            indicator = classes.minor;
            break;
        case "major":
            indicator = classes.major;
            break;
        case "critical":
            indicator = classes.critical;
            break;
        case "maintenance":
            indicator = classes.maintenance;
            break;
    }
    return /*#__PURE__*/ React.createElement(ContrastLink, {
        href: "https://status.blackbird.online",
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes.statusContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: "".concat(classes.statusIndicator, " ").concat(indicator)
    }), t([
        "shared:statusPage"
    ], {
        defaultValue: "Status"
    })));
};
export default StatusPage;
